export default (theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: '8px 16px',
        boxSizing: 'border-box',
        backgroundColor: theme.colors.background.jadeT7,
    },
    content: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
    },
    label: {
        display: 'inline',
    },
    link: {
        color: theme.colors.actionMajor[500],
        textDecoration: 'none',
        '&:hover': {
            color: theme.colors.actionMajor[600],
        },
    },
});
